import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "7ee04YwV2RPBbBJx9gZUOpI", "RotateAct", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, Enum, tween, Tween } from "cc";
var ccclass = _decorator.ccclass,
    property = _decorator.property,
    menu = _decorator.menu;
export var E_RotateType;

(function (E_RotateType) {
  E_RotateType[E_RotateType["Normal"] = 0] = "Normal";
  E_RotateType[E_RotateType["NormalDelay"] = 1] = "NormalDelay";
})(E_RotateType || (E_RotateType = {}));

var RotateAct = (_dec = menu("act/RotateAct"), _dec2 = property({
  type: Enum(E_RotateType),
  tooltip: "进度条类型"
}), _dec3 = property({
  tooltip: "the angle changed in one second"
}), _dec4 = property({
  tooltip: "是否加载后，直接播放"
}), ccclass(_class = _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(RotateAct, _Component);

  function RotateAct() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "type", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "speed", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "delayTime", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "isPlayedOnLoad", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "clockwise", _descriptor5, _assertThisInitialized(_this));

    return _this;
  }

  var _proto = RotateAct.prototype;

  // onLoad () {}
  _proto.start = function start() {
    if (this.isPlayedOnLoad) {
      this.act();
    }
  };

  _proto.act = function act(callFunc) {
    if (callFunc === void 0) {
      callFunc = null;
    }

    switch (this.type) {
      case E_RotateType.Normal:
        this.handle_normal();
        break;

      case E_RotateType.NormalDelay:
        this.handle_normalDelay();
        break;
    }
  };

  _proto.handle_normal = function handle_normal() {
    var aimSpeed = this.clockwise ? this.speed : this.speed * -1;
    tween(this.node).repeatForever(tween().by(1, {
      angle: aimSpeed
    })).start();
  };

  _proto.handle_normalDelay = function handle_normalDelay() {
    var aimSpeed = this.clockwise ? this.speed : this.speed * -1;
    tween(this.node).repeatForever(tween().by(1, {
      angle: aimSpeed
    }).delay(1)).start();
  };

  _proto.reset = function reset() {
    Tween.stopAllByTarget(this.node);
    this.act();
  } // update (dt) {}
  ;

  return RotateAct;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return E_RotateType.Normal;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "speed", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 180;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "delayTime", [property], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 1;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "isPlayedOnLoad", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "clockwise", [property], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
})), _class2)) || _class) || _class);
export { RotateAct as default };

_cclegacy._RF.pop();